import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";


import "./Tcops.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import "./Ev.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import BrochurePopup from "../components/BrochurePopup";
import evBrochure from "../components/images/EV BROCHURE 2026.pdf";

import hero1 from "../components/images/slide.png";
import hero2 from "../components/images/slide1.png";
import hero3 from "../components/images/slide2.png";
import hero4 from "../components/images/slide3.png";
import ecoFriendly from "../components/images/Eco-Friendly.gif";
import longBattery from "../components/images/Long Battery Life.gif";
import stylishDesign from "../components/images/Stylish Design.gif";
import costEffective from "../components/images/Cost-Effective.gif";
import s1 from "../components/images/s1.jpeg";
import s2 from "../components/images/s2.jpeg";
import s3 from "../components/images/s3.jpeg";
import s4 from "../components/images/s4.jpeg";
import s5 from "../components/images/s5.jpeg";
import s6 from "../components/images/s6.jpeg";



import activaSupremeLd from "../components/images/ACTIVA SUPREME LD.jpg";
import chetak from "../components/images/CHETAK.jpg";
import dhl from "../components/images/DHL.jpg";
import e4 from "../components/images/E4.jpg";
import handicap from "../components/images/HANDICAP.jpg";
import loader from "../components/images/LOADER.jpg";
import shl from "../components/images/SHL.jpg";
import vespaULight from "../components/images/VESPA U LIGHT.jpg";
import activaOld from "../components/images/ACTIVA OLD.jpg";
import activaPro from "../components/images/ACTIVA PRO.jpg";


const bannerImages = [hero1, hero2, hero3, hero4];

const Ev = () => {


   const settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false,
    pauseOnHover: false
  };
  const [open, setOpen] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
const navigate = useNavigate();
  /* Accordion toggle */
  const toggleDetails = (id) => {
    setOpen(open === id ? null : id);
  };

  /* Auto banner slider */
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % bannerImages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const AccordionItem = ({ id, title, content }) => (
    <div className={`accordion-item ${open === id ? "active" : ""}`}>
      <div className="accordion-header" onClick={() => toggleDetails(id)}>
        <h3>{title}</h3>
        <span>{open === id ? "−" : "+"}</span>
      </div>

      <div className={`accordion-body ${open === id ? "show" : ""}`}>
        <p>{content}</p>
      </div>
    </div>
  );

  return (
    <>
 <BrochurePopup
        brochure={evBrochure}
        title="EV Brochure 2026"
        subtitle="Meet Redwolf Electric Vehicles – powerful performance, long range, smart technology and eco-friendly rides."
        fileName="Redwolf-EV-Brochure-2026.pdf"
        icon="⚡"
      />
      <div className="ev-banner-wrapper">
  <Slider {...settings}>
    {bannerImages.map((image, index) => (
      <div key={index} className="ev-slide-item">
        <img
          src={image}
          alt={`EV Banner ${index + 1}`}
          className="ev-banner-image"
        />
     
      </div>
    ))}
  </Slider>
</div>

 {/* <div className="tcops-slider">
        <Slider {...settings}>
          {bannerImages.map((image, index) => (
            <div key={index}>
              <img src={image} alt={`Banner ${index + 1}`} className="slider-image" />
            </div>
          ))}
        </Slider>
      </div>  */}

      {/* <section className="banner-slider">
        <div
          className="banner-track"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {bannerImages.map((img, index) => (
            <div className="banner-slide" key={index}>
              <img src={img} alt={`Banner ${index + 1}`} />
            </div>
          ))}
        </div>
      </section> */}
      {/* HERO SLIDER */}
  {/* HERO SLIDER */}
{/* <section className="hero">
  <div id="slider-wrapper">
    <div className="inner-wrapper">

      <input
        defaultChecked
        type="radio"
        name="slide"
        className="control"
        id="Slide1"
      />
      <label htmlFor="Slide1" id="s1">
        <img src={hero1} alt="Hero 1" />
      </label>

      <input
        type="radio"
        name="slide"
        className="control"
        id="Slide2"
      />
      <label htmlFor="Slide2" id="s2">
        <img src={hero2} alt="Hero 2" />
      </label>

      <input
        type="radio"
        name="slide"
        className="control"
        id="Slide3"
      />
      <label htmlFor="Slide3" id="s3">
        <img src={hero3} alt="Hero 3" />
      </label>

      <input
        type="radio"
        name="slide"
        className="control"
        id="Slide4"
      />
      <label htmlFor="Slide4" id="s4">
        <img src={hero4} alt="Hero 4" />
      </label>

    </div>
  </div>
</section> */}


      {/* HERO CONTENT */}
      <section className="her">
        <div className="hero-overlay">
          <h2>Redefining the Way You Ride</h2>
          <p className="about-us-container">
            Step into the future of transportation with Red Wolf electric scooters. Designed to be efficient, eco-friendly, and sleek, they deliver a smarter, cleaner, and more stylish way to move—today and tomorrow.


          </p>
              <a
        href={evBrochure}
        download
        className="brochure-btn ev-btn"
      >
        ⚡ Download EV Brochure
      </a>
          {/* <button
            className="book-now-button"
            onClick={() => (window.location.href = "/contact")}
          >
            Book Now
          </button> */}
        </div>
      </section>

      {/* FEATURES CARDS */}
      {/* <section id="features" className="features">
        <h2>Why Choose Red Wolf Electric Scooter?</h2>

        <div className="feature-cards">
          <div className="feature-card">
            <img src="image/Eco-Friendly.gif" alt="Eco Friendly" />
            <h3>Eco-Friendly</h3>
            <p>Reduce your carbon footprint with our electric scooter.</p>
          </div>

          <div className="feature-card">
            <img src="assets/Long Battery Life.gif" alt="Battery" />
            <h3>Long Battery Life</h3>
            <p>High-performance battery with long range.</p>
          </div>

          <div className="feature-card">
            <img src="assets/Stylish Design.gif" alt="Design" />
            <h3>Stylish Design</h3>
            <p>Modern, sleek and futuristic scooter.</p>
          </div>

          <div className="feature-card">
            <img src="assets/Cost-Effective.gif" alt="Cost" />
            <h3>Cost Effective</h3>
            <p>Save money on fuel and maintenance.</p>
          </div>
        </div>
      </section> */}

      {/* <section id="features" className="features">
  <h2>Why Choose Red Wolf Electric Scooter?</h2>

  <div className="feature-cards">
    <div className="feature-card">
      <img src={ecoFriendly} alt="Eco Friendly" />
      <h3>Eco-Friendly</h3>
      <p>Reduce your carbon footprint with our 100% electric-powered scooter. Contribute to a cleaner, greener future.</p>
    </div>

    <div className="feature-card">
      <img src={longBattery} alt="Long Battery Life" />
      <h3>Long Battery Life</h3>
      <p>HOur electric scooter comes with a high-performance battery that offers long-range and quick charging capabilities.</p>
    </div>

    <div className="feature-card">
      <img src={stylishDesign} alt="Stylish Design" />
      <h3>Stylish Design</h3>
      <p>Ride in style with a modern, sleek, and futuristic design that blends functionality with aesthetics.</p>
    </div>

    <div className="feature-card">
      <img src={costEffective} alt="Cost Effective" />
      <h3>Cost Effective</h3>
      <p>Save money on fuel and maintenance with our affordable electric scooter. It’s the cost-effective way to commute.</p>
    </div>
  </div>
</section> */}
<section id="features" className="features">
  <h2>Why Choose Red Wolf Electric Scooters?</h2>

  <div className="feature-cards">

    <div className="feature-card">
      <img src={ecoFriendly} alt="Comprehensive Warranty" />
      <h3>Comprehensive Warranty</h3>
      <p>
        Enjoy peace of mind with our reliable battery warranty coverage,
        ensuring long-term performance and protection for your investment.
      </p>
    </div>

    <div className="feature-card">
      <img src={longBattery} alt="Low Energy Consumption" />
      <h3>Low Energy Consumption</h3>
      <p>
        Designed for energy efficiency, Red Wolf scooters consume minimal
        electricity per charge, helping you save more on running costs.
      </p>
    </div>

    <div className="feature-card">
      <img src={stylishDesign} alt="Fast & Reliable Delivery" />
      <h3>Fast & Reliable Delivery</h3>
      <p>
        Experience smooth and prompt delivery with proper pre-delivery
        inspection to ensure your scooter is ready to ride from day one.
      </p>
    </div>

    <div className="feature-card">
      <img src={costEffective} alt="Dedicated After-Sales Service" />
      <h3>Dedicated After-Sales Service</h3>
      <p>
        Our professional service support team ensures hassle-free
        assistance whenever you need it.
      </p>
    </div>

    {/* <div className="feature-card">
      <img src={costEffective} alt="Cost-Effective Ownership" />
      <h3>Cost-Effective Ownership</h3>
      <p>
        With low charging costs and minimal maintenance, Red Wolf offers
        an economical solution for everyday commuting.
      </p>
    </div> */}

  </div>
</section>


      {/* SPECIFICATIONS */}
<h2 className="spec-heading">
  <span className="spec-red">SPECIFI</span>
  <span className="spec-green">CATIONS</span>
</h2>


<section id="specifications" className="spec-section">


  <div className="spec-container">
    <div className="spec-box">
      <ul>
        <li><span>Max Speed:</span> 25 km/h</li>
        <li><span>Range:</span> 50–150 KM per charge</li>
        <li><span>Battery Type:</span> LFP </li>
        <li><span>Charging Time:</span> 6–8 Hrs / 3–4 Hrs</li>
        <li><span>Power:</span> 48V / 60V / 72V</li>
      </ul>
    </div>

    <div className="spec-box">
      <ul>
        <li><span>Weight:</span> 75 kg</li>
        <li><span>Brakes:</span> Disc / Drum</li>
        <li><span>Motor:</span> BLDC</li>
        <li><span>Wheel Type:</span> Alloy</li>
        <li><span>Gear:</span> 3 Forward & 1 Reverse</li>
      </ul>
    </div>
  </div>
</section>

{/* <section class="offer-section">
  <h2>Limited Time Offer!</h2>
  <p>
    Get a discount of <strong>10%</strong> on your first order of the Red Wolf
    Electric Scooter. Don’t miss out!
  </p>
  <a href="#order" class="offer-btn">Claim Discount</a>
</section> */}

{/* <section class="experience-section">
  <h2>Ready to Experience the Future of Riding?</h2>
  <p>
    Take a step toward a greener future with Red Wolf Info Tech  Electric Scooter. Order now and revolutionize your daily commute.


  </p>
  <a href="/contact" class="experience-btn">Order Now</a>
</section> */}


<section class="experience-section">
  <h2>Ready to Ride Into the Future?</h2>
  <p>
    Take a step toward a greener future with Red Wolf electric scooters. 
    Experience smarter mobility and transform your everyday commute—starting today.
  </p>
  <a href="/contact" class="experience-btn">Order Now</a>
</section>


     {/* PRODUCT SLIDER */}



{/* <section className="product-slider">
      <h2 className="spec-heading">
        <span className="spec-red">Top Electric</span>
        <span className="spec-green"> Scooters</span>
      </h2>

      <Swiper
        spaceBetween={30}
        slidesPerView={5}
        loop={true}
        speed={1000}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          320: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 5 },
        }}
      >
        {[
          { name: "BETA", img: s1 },
          { name: "ALPHA", img: s2 },
          { name: "GAMMA", img: s3 },
          { name: "MARS", img: s4 },
          { name: "VENUS", img: s5 },
          { name: "NEPTUNE", img: s6 },
        ].map((item, i) => (
          <SwiperSlide key={i}>
          
            <div className="card">
              <img src={item.img} alt={item.name}  onClick={() => navigate("/contact")}/>

              <div className="card-content">
                <h3>{item.name}</h3>

              </div>
            </div>
          </SwiperSlide>
          
        ))}
        
      </Swiper>
      
    </section> */}



    <section className="product-slider">
  <h2 className="spec-heading">
    <span className="spec-red">Top Electric</span>
    <span className="spec-green"> Scooters</span>
  </h2>

  <Swiper
    spaceBetween={24}
    loop={true}
    speed={900}
    autoplay={{
      delay: 2500,
      disableOnInteraction: false,
    }}
    breakpoints={{
      320: { slidesPerView: 1.2 },
      576: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 5 },
    }}
  >
   {[
  { name: "ACTIVA OLD", img: activaOld },
  { name: "ACTIVA PRO", img: activaPro },
  { name: "ACTIVA SUPREME LD", img: activaSupremeLd },
  { name: "CHETAK", img: chetak },
  { name: "VESPA U LIGHT", img: vespaULight },
  { name: "E4", img: e4 },
  { name: "DHL", img: dhl },          // ✅ added
  { name: "SHL", img: shl },          // ✅ added
  { name: "LOADER", img: loader },
  { name: "HANDICAP", img: handicap },
].map((item, i) => (
  <SwiperSlide key={i}>
    <div
      className="ev-card"
      onClick={() => navigate("/contact")}
    >
      <div className="ev-img">
        <img src={item.img} alt={item.name} />
      </div>

      <div className="ev-card-content">
        <h3>{item.name}</h3>
      </div>
    </div>
  </SwiperSlide>
))}

  </Swiper>
</section>




      {/* FEATURES & BENEFITS ACCORDION */}
     <section className="features-benefits">
<h2 className="spec-heading">
  <span className="spec-red">Fea</span>
  <span className="spec-green">tures</span>
</h2>


  {[
    {
      id: "feature1",
      title: "1. Eco-Friendly Performance ",
      content:
        "With zero tailpipe emissions, EVs contribute to a cleaner environment andasmaller carbon footprint.",
    },
    {
      id: "feature2",
      title: "2. Low Running Costs",
      content:
        " Charging an EV is significantly more economical than fueling with petrol or deisel.",
    },
    {
      id: "feature3",
      title: "3. Stylish Design",
      content:
        " Crafted with sleek and modern design that stands out on every road.",
    },
    {
      id: "feature4",
      title: "4. Instant Torque Delivery ",
      content:
        " Allowing fast and smooth acceleration without waiting for the engine to build power.",
    },
    {
      id: "feature5",
      title: "5. Long Battery Life",
      content:
        " Advanced battery technology ensures extended range and reliable performance for longer journeys.",
    },
  ].map((item) => (
    <AccordionItem
      key={item.id}
      {...item}
      open={open}
      toggle={toggleDetails}
    />
  ))}

<h2 className="spec-heading">
  <span className="spec-red">Bene</span>
  <span className="spec-green">fits</span>
</h2>


  {[
    {
      id: "benefit1",
      title: "1. Lower Carbon Emissions ",
      content:
        "By replacing petrol or diesel with electricity-EVs help lower overall carbon footprint.",
    },
    {
      id: "benefit2",
      title: "2. Reduced Energy Costs ",
      content:
        "With a lower cost per mile and the convenience of home charging, EVs offer a cost- effective solution for daily commuting.",
    },
    {
      id: "benefit3",
      title: "3. Government Tax Benefits ",
      content:
        "Eligible for various government incentives and tax benefits, reducing the overall purchase cost and making EV ownership more affordable.",
    },
    {
      id: "benefit4",
      title: "4. Minimal Maintenance ",
      content:
        " With fewer moving parts and no engine oil requirements, EVs require significantlyless maintenance compared to conventional vehicles.",
    },
    {
      id: "benefit5",
      title: "5. Silent Riding Comfort ",
      content:
        "Experience near-silent performance and seamless motion-where every drive feels calm, refined, and effortless.",
    },
  ].map((item) => (
    <AccordionItem
      key={item.id}
      {...item}
      open={open}
      toggle={toggleDetails}
    />
  ))}
</section>

<section className="ev-brochure-section">
  <div className="ev-brochure-card">
    <div className="ev-brochure-content">
      <h2>
        Get the Complete <span>EV Guide</span>
      </h2>

      <p>
        Explore our electric vehicle lineup with detailed specifications,
        battery performance, range insights, charging solutions, and
        warranty information—all in one easy-to-download brochure.
      </p>

      <a
        href={evBrochure}
        download
        className="brochure-btn ev-btn"
      >
        ⚡ Download EV Brochure
      </a>
    </div>
  </div>
</section>


{/* <section className="ev-brochure-section">
  <div className="ev-brochure-card">
    <div className="ev-brochure-content">
      <h2>
        Download <span>EV Brochure</span>
      </h2>

      <p>
        Explore our Electric Vehicle range with complete specifications,
        battery details, range, charging options, and warranty information
        in one downloadable PDF.
      </p>

      <a
        href={evBrochure}
        download
        className="brochure-btn ev-btn"
      >
        ⚡ Download EV Brochure
      </a>
    </div>
  </div>
</section> */}



    </>
  );
};

export default Ev;
